import GalleryImage1 from 'assets/img/carousel/festa-1.png';
import GalleryImage2 from 'assets/img/carousel/241125_TeaserKicks_TeaserExt-02.png';
import GalleryImage3 from 'assets/img/carousel/241125_TeaserKicks_TeaserExt-03.png';
import GalleryImage4 from 'assets/img/carousel/241125_TeaserKicks_TeaserInt-06.png';
import GalleryImage5 from 'assets/img/carousel/241125_TeaserKicks_TeaserInt-07.png';
import GalleryImage6 from 'assets/img/carousel/multi.png';
import GalleryImage7 from 'assets/img/carousel/roda.png';
import GalleryImage8 from 'assets/img/carousel/volante-midia.png';
import GalleryMobileImage1 from 'assets/img/carousel/mobile/festa-1.png';
import GalleryMobileImage2 from 'assets/img/carousel/mobile/241125_TeaserKicks_TeaserExt-02.png';
import GalleryMobileImage3 from 'assets/img/carousel/mobile/241125_TeaserKicks_TeaserExt-03.png';
import GalleryMobileImage4 from 'assets/img/carousel/mobile/241125_TeaserKicks_TeaserInt-06.png';
import GalleryMobileImage5 from 'assets/img/carousel/mobile/241125_TeaserKicks_TeaserInt-07.png';
import GalleryMobileImage6 from 'assets/img/carousel/mobile/multi.png';
import GalleryMobileImage7 from 'assets/img/carousel/mobile/roda.png';
import GalleryMobileImage8 from 'assets/img/carousel/mobile/volante-midia.png';

export const data = {
    desktop: [
        GalleryImage1,
        GalleryImage2,
        GalleryImage3,
        GalleryImage4,
        GalleryImage5,
        GalleryImage6,
        GalleryImage7,
        GalleryImage8,
    ],
    mobile: [
        GalleryMobileImage1,
        GalleryMobileImage2,
        GalleryMobileImage3,
        GalleryMobileImage4,
        GalleryMobileImage5,
        GalleryMobileImage6,
        GalleryMobileImage7,
        GalleryMobileImage8,
    ]
};